// Debug navigation issues
export const debugNavigation = {
  install(app) {
    // Add global error handler
    app.config.errorHandler = (error, instance, info) => {
      console.error('Vue Error:', error);
      console.error('Component:', instance?.$options.name || 'Unknown');
      console.error('Error Info:', info);
      console.error('Stack:', error.stack);
    };

    // Add router debug hooks
    const router = app.config.globalProperties.$router;
    
    if (router) {
      router.beforeEach((to, from, next) => {
        console.log(`[Router] Before navigation: ${from.path} -> ${to.path}`);
        console.log('[Router] To route:', to);
        console.log('[Router] From route:', from);
        next();
      });

      router.afterEach((to, from) => {
        console.log(`[Router] After navigation: ${from.path} -> ${to.path}`);
        console.log('[Router] Current route components:', to.matched.map(r => r.components));
        
        // Check if components are properly loaded
        setTimeout(() => {
          const app = document.getElementById('app');
          console.log('[DOM] App element:', app);
          console.log('[DOM] App innerHTML length:', app?.innerHTML.length);
          console.log('[DOM] Visible elements:', document.querySelectorAll('section, .hero-section, .top-view').length);
          
          // Check for specific components
          console.log('[Components] TopView:', !!document.querySelector('.top-view'));
          console.log('[Components] HeroSection:', !!document.querySelector('.hero-section'));
          console.log('[Components] GoogleMap:', !!document.querySelector('.GMap'));
        }, 100);
      });

      router.onError((error) => {
        console.error('[Router] Navigation error:', error);
      });
    }
  }
};